import React, { Component } from "react";
import VerticalLayout from "../../layout/VerticalLayout";
import HorizontalAdaptLayout from "../../layout/adapt/HorizontalAdaptLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class HorizontalAdaptLayoutDemo extends Component {
  render() {
    return (
      <VerticalLayout>
        <HorizontalAdaptLayout>
          <HorizontalAdaptLayout.Item width={150}>
            <CenterLayout className="bg1">水平自适应 1</CenterLayout>
          </HorizontalAdaptLayout.Item>
          <HorizontalAdaptLayout.Item width={150}>
            <CenterLayout className="bg2">水平自适应 2</CenterLayout>
          </HorizontalAdaptLayout.Item>
          <HorizontalAdaptLayout.Item width={150}>
            <CenterLayout className="bg3">水平自适应 3</CenterLayout>
          </HorizontalAdaptLayout.Item>
          <HorizontalAdaptLayout.Item width={150}>
            <CenterLayout className="bg4">水平自适应 4</CenterLayout>
          </HorizontalAdaptLayout.Item>
          <HorizontalAdaptLayout.Item>
            <CenterLayout className="bg5">
              水平自适应 fill 5水平自适应 fill 5水平自适应 fill 5水平自适应 fill
              5水平自适应 fill 5水平自适应 fill 5水平自适应 fill 5水平自适应
              fill 5
            </CenterLayout>
          </HorizontalAdaptLayout.Item>
        </HorizontalAdaptLayout>
      </VerticalLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.horizontalAdaptLayout.js